"use strict";

angular.module("vendor")
.controller("SectionOrderDetails", function(
    $scope, $stateParams, VendorOrderService
) {
    $scope.order = null;
    $scope.orderId = $stateParams.id;
    $scope.service = VendorOrderService;
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/order/order-detail.controller.js
// module id = 987
// module chunks = 0